import axios from "axios";

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;

export const RaiseInsuranceEnquiry = async (requestBody) => {
  console.log("Url",REACT_APP_API+"/api/Reservations/Insurance/CreateInsuranceEnquiry")
  try {
    const resp = await axios.post(
      `${REACT_APP_API}/api/Reservations/Insurance/CreateInsuranceEnquiry`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return resp.data;
  } catch (err) {
    console.error("flightAvailability error:", err);
    throw err;
  }
};

export const RaiseForexEnquiry = async (requestBody) => {
  try {
    const resp = await axios.post(
      `${REACT_APP_API}/api/Reservations/Forex/CreateForexEnquiry`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return resp.data;
  } catch (err) {
    console.error("Raise Forex Enquiry  error:", err);
    throw err;
  }
};


export const RaiseCabEnquiry = async (requestBody) => {
    console.log("Url",REACT_APP_API+"/api/Reservations/Cabs/CreateCabEnquiry")
  try {
    const resp = await axios.post(
      `${REACT_APP_API}/api/Reservations/Cabs/CreateCabEnquiry`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return resp.data;
  } catch (err) {
    console.error("Raise Forex Enquiry  error:", err);
    throw err;
  }
};

//RaiseVisaEnquiry
export const RaiseVisaEnquiry = async (requestBody) => {
    console.log("Url",REACT_APP_API+"/api/Reservations/Visa/CreateVisaEnquiry")
  try {
    const resp = await axios.post(
      `${REACT_APP_API}/api/Reservations/Visa/CreateVisaEnquiry`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return resp.data;
  } catch (err) {
    console.error("Raise Forex Enquiry  error:", err);
    throw err;
  }
};

//RaisebusEnquiry
export const RaisebusEnquiry = async (requestBody) => {
    console.log("Url",REACT_APP_API+"/api/Reservations/Bus/CreateBusEnquiry")
  try {
    const resp = await axios.post(
      `${REACT_APP_API}/api/Reservations/Bus/CreateBusEnquiry`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return resp.data;
  } catch (err) {
    console.error("Raise Bus Enquiry  error:", err);
    throw err;
  }
};

//RaiseTrainEnquiry
export const RaiseTrainEnquiry = async (requestBody) => {
    console.log("Url",REACT_APP_API+"/api/Reservations/Rail/CreateTrainEnquiry")
  try {
    const resp = await axios.post(
      `${REACT_APP_API}/api/Reservations/Rail/CreateTrainEnquiry`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return resp.data;
  } catch (err) {
    console.error("Raise Train Enquiry  error:", err);
    throw err;
  }
};